<template>
  <footer class="footer">
    <div class="container">
      <div class="columns">
        <div class="column footer-col">
          <EditField v-model="fields['col1']" page="all"></EditField>
        </div>

        <div class="column footer-col address">
          <EditField v-model="fields['col2']" page="all"></EditField>

          <ul>
            <li>
              <span class="icon">
                <i class="fas fa-map-marker-alt"></i>
              </span>
              <EditField v-model="fields['address1']" page="all"></EditField>
            </li>

            <li>
              <span class="icon">
                <i class="fas fa-envelope"></i>
              </span>
              <EditField v-model="fields['address2']" page="all"></EditField>
            </li>

            <li>
              <span class="icon">
                <i class="fas fa-phone"></i>
              </span>
              <EditField v-model="fields['address3']" page="all"></EditField>
            </li>
          </ul>
        </div>

        <div class="column footer-col is-hidden-mobile">
          <EditField v-model="fields['col3']" page="all"></EditField>

          <div class="columns">
            <div v-if="$store.state.auth.success" class="column is-3-desktop">
              <button
                class="button is-small is-primary is-rounded"
                @click="showAddSocialModal = true"
              >
                <span class="icon">
                  <i class="fas fa-plus-circle"></i>
                </span>
                <span>Lägg till</span>
              </button>
            </div>
            <div
              v-for="item in socials"
              :key="item.card.uid"
              class="column is-2-desktop"
              :draggable="$store.state.auth.success"
              @dragstart="ordering = item"
              @dragover.prevent
              @drop="Reorder(item)"
            >
              <a
                :href="!$store.state.auth.success ? item.card.address : false"
                :target="ordering ? false : '_blank'"
                :class="{ grabable: $store.state.auth.success }"
              >
                <div class="admin-row-wrapper">
                  <div v-if="$store.state.auth.success" class="admin-row2">
                    <div
                      class="delete"
                      @click="
                        socialToDelete = item;
                        showDeleteSocialModal = true;
                      "
                    ></div>
                  </div>
                  <figure class="image is-32x32">
                    <img
                      v-if="item.images.length != 0"
                      class="is-unselectable"
                      draggable="false"
                      :src="`${$helpers.url}image/${item.images[0].name}`"
                    />
                  </figure>
                </div>
              </a>
            </div>
          </div>
        </div>

        <!-- <div class="column footer-col is-hidden-tablet">
          <h3 class="title is-4 is-uppercase">Sitekarta</h3>
          <ul>            
            <li><router-link to="/om-oss">Om oss</router-link></li>
            <li><router-link to="/om-oss">Kontakt</router-link></li>
            <li><router-link to="/om-oss">Projekt</router-link></li>
            <li><router-link to="/om-oss">Jobb</router-link></li>
          </ul>
        </div>-->
      </div>

      <div class="columns">
        <div class="column">
          <div class="content has-text-centered">
            <p class="is-size-6">
              <i>
                <router-link
                  class="is-inline nu has-text-dark pr nolink"
                  to="/signin"
                  >© 1995-{{ new Date().getFullYear() }}</router-link
                >&nbsp;
                <EditField v-model="fields['copyright']" page="all"></EditField>
              </i>
            </p>
          </div>
        </div>
      </div>
    </div>
    <EditImageLink
      v-model="showAddSocialModal"
      @saved="
        socials = [$event, ...socials];
        socials = OrderItems(socials);
      "
    ></EditImageLink>

    <DeleteConfirm
      v-model="showDeleteSocialModal"
      title="Ta bort social kanal"
      :deleteFunc="DeleteSocial"
      message="Sociala kanalen är borttagen."
      @deleted="
        socials = socials.filter(x => x.card.uid != socialToDelete.card.uid)
      "
    >
      <p>Du är på väg att ta bort en social kanal.</p>
    </DeleteConfirm>
  </footer>
</template>

<script>
import EditSingleField from "@/components/singles/EditSingleField/component.vue";
import EditField from "@/components/main/EditField.vue";
import EditImageLink from "@/components/main/EditImageLink.vue";
import DeleteConfirm from "@/components/main/DeleteConfirm.vue";

export default {
  components: { EditSingleField, EditField, EditImageLink, DeleteConfirm },
  data() {
    return {
      socialToDelete: null,
      showDeleteSocialModal: false,
      ordering: null,
      showAddSocialModal: false,
      ready: false,
      fields: {
        head1: { value: null },
        head2: { value: null },
        head3: { value: null },
        col1: { value: null },
        col2: { value: null },
        col3: { value: null },
        address1: { value: null },
        address2: { value: null },
        address3: { value: null },
        copyright: { value: null }
      },
      socials: []
    };
  },
  async created() {
    this.fields = await this.$helpers.GetPageFields(this.fields, "all");
    this.ready = true;
    this.CheckLinks();
    this.GetSocials();
  },
  mounted() {},
  methods: {
    async DeleteSocial() {
      return this.$helpers.PostApi("delete/card", {
        pageName: "all",
        uid: this.socialToDelete.card.uid
      });
    },
    async Reorder(item) {
      if (
        this.$store.state.auth.role.level <= 2 &&
        item.card.uid != this.ordering.card.uid
      ) {
        let order = this.ordering.card.order;

        this.ordering.card.order = item.card.order;
        item.card.order = order;

        await this.$helpers.PostApi("set/pageCard", {
          pageName: "all",
          uid: this.ordering.card.uid,
          object: { order: this.ordering.card.order }
        });

        await this.$helpers.PostApi("set/pageCard", {
          pageName: "all",
          uid: item.card.uid,
          object: { order: item.card.order }
        });

        this.socials = this.OrderItems(this.socials);
        this.$helpers.ShowStatus("Sparat.", 3000);
        this.ordering = null;
      }
    },
    async GetSocials() {
      let result = await this.$helpers.PostApi(
        "get/pageCards",
        {
          pageName: "all",
          active: this.$store.state.auth.role.level <= 2 ? null : true,
          cover: null
        },
        true
      );

      this.socials = this.OrderItems(result);
    },
    OrderItems(items) {
      return [...items].sort((a, b) => {
        if (a.card.order > b.card.order) {
          return 1;
        }
        if (b.card.order > a.card.order) {
          return -1;
        }

        return 0;
      });
    },
    CheckLinks() {
      setTimeout(() => {
        let anchors = document.getElementsByTagName("a");
        for (let a of anchors) {
          if (
            !a.attributes[0].name.startsWith("data") &&
            !a.getAttribute("href").includes("mailto:") &&
            !a.getAttribute("href").includes("tel:")
          ) {
            a.onclick = e => {
              e.preventDefault();
              this.$router.push({
                path: a.getAttribute("href")
              });
            };
          }
        }
      });
    }
  }
};
</script>
